import { makeStyles } from "tss-react/mui";
import { MiChip } from "@miplatform/components";

export function BidDueDateChip({ daysUntilDue }: { daysUntilDue: number }) {
  const { classes, cx } = useStyles();

  const isDateApproaching = daysUntilDue <= 2 && daysUntilDue >= 0;
  const isDatePast = daysUntilDue < 0;

  const label = isDateApproaching
    ? `${daysUntilDue} day${daysUntilDue === 1 ? "" : "s"} left`
    : isDatePast
    ? `${Math.abs(daysUntilDue)} day${
        Math.abs(daysUntilDue) === 1 ? "" : "s"
      } past`
    : "";

  return (
    <MiChip
      label={label}
      size="small"
      className={cx(classes.chip, {
        [classes.warning]: isDateApproaching,
        [classes.pastDue]: isDatePast,
      })}
    />
  );
}

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderRadius: 2,
    height: 18,
    fontWeight: theme.fontWeight.regular,
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1),
      fontSize: theme.fontSize.small,
    },
  },
  warning: {
    border: `1px solid ${theme.palette.orange.dark}`,
    color: theme.palette.orange.dark,
    backgroundColor: theme.palette.orange.light,
  },
  pastDue: {
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
}));
